import { NgModule } from '@angular/core';
import { MsTabsComponent } from './ms-tabs.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsTabsComponent],
	imports: [SharedLibsModule],
	exports: [MsTabsComponent],
	providers: [],
})
export class MsTabsModule {}
